module.exports = __webpack_public_path__ + "img/mp.d646f4f0.png";